import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { Modal, Dropdown } from 'app/components';
import { MapPin } from '@phosphor-icons/react';
import { getCities } from '../../api';
import { INDIAN_CITIES } from '../../../event-create/constants/data.js'
import { getPrimaryEventById } from '../../../event-buyerflow/api';
import { getEventById } from '../../../event-dashboard/api';
import './style';

const LocationModal = () => {
  const [selectedCity, setSelectedCity] = useState({ id: '' });
  const [isOpen, setIsOpen] = useState(false);
  const { cities } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    getCities();
  }, []);

  useEffect(() => {
    const isIdRoute = /^\/[a-zA-Z0-9]{24,}$/.test(location.pathname);
    const isEventRoute = /^\/event\/[a-zA-Z0-9]{24,}$/.test(location.pathname);
    const isPublicRoute = /^\/(terms-and-conditions|privacy-policy)$/.test(location.pathname);
    const storedCity = localStorage.getItem('selectedCity');

    if (isEventRoute && cities && selectedCity.id === '') {
      const id = location.pathname.slice(7);
      console.log('Event ID:', id);
      console.log('Available cities:', cities);
      
      getPrimaryEventById(id, (data) => {
        console.log('Event data:', data);
        if (data.payload) {
          const eventState = data.payload.geo_location;
          const city = cities.find((city) => city.label.toLowerCase() === eventState.toLowerCase());        
          if (city) {
            console.log('Setting city:', city);
            setSelectedCity(city);
            dispatch({ type: 'SELECTED_CITY:DATA:SET', data: city });
            localStorage.setItem('selectedCity', JSON.stringify(city));
          }
        }
      });
    } else if (!isIdRoute && !isPublicRoute && !storedCity && !isEventRoute) {
      setIsOpen(true);
    }
  }, [location.pathname, cities]);

  useEffect(() => {
    const storedCity = localStorage.getItem('selectedCity');
    console.log('Stored city:', storedCity);
    if (storedCity && cities) {
      try {
        const parsedCity = JSON.parse(storedCity);
        console.log('Parsed city:', parsedCity);
        setSelectedCity(parsedCity);
      } catch (error) {
        console.error('Error parsing stored city:', error);
      }
    }
  }, [cities]);

  const handleCityChange = (value) => {
    console.log('City change value:', value);
    const newSelectedCity = cities.find(
      (option) => option.id === value,
    );
    console.log('New selected city:', newSelectedCity);
    if (newSelectedCity) {
      setSelectedCity(newSelectedCity);
      dispatch({ type: 'SELECTED_CITY:DATA:SET', data: newSelectedCity });
      localStorage.setItem('selectedCity', JSON.stringify(newSelectedCity));
      setIsOpen(false);
    }
  };

  return (
    <Modal size="regular"
      className="location-modal z-[60]"
      isOpen={isOpen}>
      <div className="p-5 rounded-full bg-[#FFF2F2] w-fit">
        <MapPin size={32}
          fill="#FF2459" />
      </div>
      <h1 className="heading-24">Find Events near you</h1>
      <Dropdown
        options={cities}
        placeholder={'Select city'}
        value={selectedCity?.id || ''}
        onChange={handleCityChange}
        hasSearch={cities?.length > 10}
        width="100%"
        className="h-auto"
      />
    </Modal>
  );
};

export default LocationModal;
